import CrudTable from "../../components/CrudTable";

const TEVKIFAT_DEFAULTS = { name: "", rate: "", code: "", service_type: "" };
const TEVKIFAT_COLUMNS = [
  { key: "name", label: "Tanım" },
  { key: "rate", label: "Tevkifat Oranı (Yüzde)", align: "right", render: (it) => `%${it.rate}` },
  { key: "code", label: "Tevkifat Kodu", render: (it) => it.code || "—" },
  { key: "service_type", label: "İşlem / Hizmet Türü", render: (it) => it.service_type || "—" },
];
const required = (msg) => (v) => (!String(v || "").trim() ? msg : "");
const TEVKIFAT_FIELDS = [
  { key: "name", label: "Tanım", type: "text", validate: required("Tanım zorunludur") },
  {
    key: "rate", label: "Tevkifat Oranı (%)", type: "number",
    validate: (v) => {
      const n = parseFloat(String(v).replace(",", "."));
      if (isNaN(n)) return "Geçerli bir oran girin";
      if (n < 0 || n > 100) return "Oran 0-100 arasında olmalı";
      return "";
    },
  },
  {
    key: "code", label: "Tevkifat Kodu", type: "text",
    validate: (v, f, items, editId) => {
      if (!String(v || "").trim()) return "Tevkifat kodu zorunludur";
      if (items.some((i) => i.id !== editId && String(i.code || "").trim() === String(v).trim())) return "Bu tevkifat kodu zaten kayıtlı";
      return "";
    },
  },
  { key: "service_type", label: "İşlem / Hizmet Türü", type: "text", validate: required("İşlem / hizmet türü zorunludur") },
];

export default function TevkifatRates() {
  return <CrudTable resource="tevkifat-rates" title="" subtitle="" testidPrefix="tevkifat" defaults={TEVKIFAT_DEFAULTS} columns={TEVKIFAT_COLUMNS} fields={TEVKIFAT_FIELDS} />;
}
